import { useState } from "react";
import styles from "./Avatar.module.scss";
import { Bible } from "./Bible/Bible";
import NewVoice from "./NewVoice/NewVoice";
import { changeFormData } from "../../../../redux/slices/formSlice";
import { useDispatch } from "react-redux";

interface Props {
	handleSaveForm: () => void;
};

const Avatar: React.FC<Props> = ({ handleSaveForm }) => {
	const [isSaveDisabled, setIsSaveDisabled] = useState<boolean>(false);
	const [promptText, setPromptText] = useState<string>("");
	const dispatch = useDispatch();

	const handleSavePrompt = () => {
		if (isSaveDisabled) return;
		dispatch(changeFormData({ prompt: promptText }));
		handleSaveForm();
	};

	return (
		<div className={styles.avatarContainer}>
			<NewVoice />
			<Bible setIsSaveDisabled={setIsSaveDisabled} setPromptText={setPromptText} />
			{/* <Behavior /> */}
			{/* <Greeting /> */}
			<button className={`${styles.saveButton}`} onClick={handleSavePrompt} disabled={isSaveDisabled}>
				Сохранить
			</button>
		</div>
	);
};

export default Avatar;
